__webpack_require__.p = "https://medical-kiosk.greenleef.com/_next/";